module.exports = __webpack_public_path__ + "img/宁德时代.5614ae54.png";